import React from 'react';
import { IPreQualifyingQuestionsProps } from './interfaces';
import { PreQualifyingQuestionsContainer } from './containers';

export const PreQualifyingQuestions = (props: IPreQualifyingQuestionsProps) => {
  return <PreQualifyingQuestionsContainer {...props} />;
};

export default PreQualifyingQuestions;
